import { List } from 'immutable'
import { handleActions } from 'redux-actions'
import * as actions from './actions'
import { Videos, Video } from 'store/records/videos'

const handleRequest = state => {
  const items = state.get('items')
  // show spinner only at initial loading
  if (!items?.size) {
    return state.set('pending', true)
  }
  return state
}

const handleFail = state => state.set('pending', false)

const handleFetchVideosByPage = (
  state,
  {
    payload,
    meta: {
      request: {
        params: { page },
      },
    },
  }
) => {
  let items = state.get('items')

  items = [...items, ...payload]

  return state
    .set('items', List(items.map(el => new Video(el))))
    .set('pending', false)
    .set('loaded', true)
    .set('currentPage', page)
}

export default handleActions(
  {
    [actions.fetchVideosByPage]: handleRequest,
    [actions.fetchVideosByPage.fail]: handleFail,
    [actions.fetchVideosByPage.success]: handleFetchVideosByPage,
  },
  new Videos()
)
